let entity ="NOTIFICATIONS";
export const GET_ALL = `GET_ALL_${entity}`
export const GET_ALL_SUCCESS = `GET_ALL_${entity}_SUCCESS`
export const GET_ALL_FAIL = `GET_ALL_${entity}_FAIL`
export const MARK_AS_READ = `MARK_AS_READ_${entity}`
